import { render, staticRenderFns } from "./PontosManuaisForm.vue?vue&type=template&id=6b92dae8&"
import script from "./PontosManuaisForm.vue?vue&type=script&lang=js&"
export * from "./PontosManuaisForm.vue?vue&type=script&lang=js&"
import style0 from "./PontosManuaisForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports